module.exports = __webpack_public_path__ + "img/sel_Shenzhen.d0e2e402.jpg";